export const toExpressionDefault = (val) => {
  if (typeof val === "string") return val;
  if (val === undefined || val === null) return "";
  return `return ${JSON.stringify(val, null, 2)}`;
};
